// @ts-nocheck
import React, { Suspense, useRef, useState, useEffect } from "react";

//redux
import { useAppSelector, useAppDispatch } from "../../redux/hooks";

import { Canvas } from "@react-three/fiber";
import { OrbitControls, Environment } from "@react-three/drei";

// import Model from "./src/Dress_comp"
import Model from "./src/Dress-processed";
import { Picker, Texture } from "./src/Dress-processed";
import { useFrame } from "@react-three/fiber";
import { setRenderPreview } from "../../redux/data/ui/index";
import { setGifImage } from "../../redux/data/home/index";

import "./index.scss";
//hello
import GIFEncoder from "../../GIFEncoder";
// import * as ffmpeg from "fluent-ffmpeg";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import gifshot from "../../gifshot";

// Create the FFmpeg instance and load it
const ffmpeg = createFFmpeg({ log: true });

const EditableObject = () => {
  const [ready, setReady] = useState(false);
  const [success, setSuccess] = useState(false);
  const load = async () => {
    await ffmpeg.load();
    setReady(true);
  };

  useEffect(() => {
    load();
  }, []);

  // useEffect(() => {
  //   if (success) window.location.href = success;
  // });

  const convertToGif = async (pngArray) => {
    if (ready) {
      // Write the png to the FFmpeg file system
      ffmpeg.FS(
        "writeFile",
        "frame.png",
        await fetchFile(...pngArray.join(""))
      );

      // Run the FFmpeg command-line tool, converting
      // the png image into .gif file
      await ffmpeg.run(
        "-framerate",
        "1",
        "-i",
        "frame.png",
        "-f",
        "gif",
        "out.gif"
      );

      // Read the .gif file back from the FFmpeg file system
      const data = ffmpeg.FS("readFile", "out.gif");
      const url = URL.createObjectURL(
        new Blob([data.buffer], { type: "image/gif" })
      );

      if (url) setSuccess(url);
    }
  };

  const { color, texture, renderPreview } = useAppSelector(
    (state) => state.uiState
  );
  const { uploadedImage, gifImage } = useAppSelector((state) => state.appData);
  const dispatch = useAppDispatch();
  const pngDataArray = [];

  const ModelContent = () => {
    const ref = useRef();
    var encoder = new GIFEncoder();
    encoder.setRepeat(0); //0  -> loop forever //1+ -> loop n times then stop
    encoder.setDelay(500); //go to next frame every n milliseconds
    encoder.start();
    console.log(encoder);
    useFrame(async () => {
      if (gifImage) pngDataArray.length = 650;
      if (pngDataArray.length <= 628) {
        var canvas = document.querySelector("canvas");
        // var context = canvas.getContext("webgl2", {
        //   preserveDrawingBuffer: true,
        // });
        // var left = 0,
        //   top = 0;
        // var width = canvas.width,
        //   height = canvas.height;
        // var pixelData = new Uint8Array(width * height * 4);
        // var imgData = context.readPixels(
        //   left,
        //   top,
        //   width,
        //   height,
        //   context.RGBA,
        //   context.UNSIGNED_BYTE,
        //   pixelData
        // );
        // encoder.addFrame(canvas.toDataURL("image/png"));
        pngDataArray.push(canvas.toDataURL("image/png"));
        console.log("frame: ", pngDataArray.length);
      } else {
        console.log("gif image is ", gifImage, Boolean(gifImage));
        if (!gifImage) {
          try {
            // console.log(encoder);
            // encoder.start();
            // encoder.finish();
            // encoder.download("model.gif");

            try {
              // convertToGif(pngDataArray);
              console.log(gifshot);
              await gifshot.createGIF({ images: pngDataArray }, function (obj) {
                if (!obj.error) {
                  console.log("GIF created", obj.image);
                  dispatch(setGifImage(obj.image));
                  alert("Preview is ready to be downloaded");
                }
              });
            } catch (e) {
              console.log(e);
            }

            //stop rotation
            dispatch(setRenderPreview(false));
          } catch (e) {
            console.log("issue in saving model GIF");
          }
        }
      }

      try {
        return (ref.current.rotation.y = ref.current.rotation.y + 0.01);
      } catch (e) {
        console.log("model rotation stopped");
        return null;
      }
    });

    return <Model previewRef={ref} />;
  };

  return (
    <div id="the-3d-object">
      {color && <Picker />}
      {texture && <Texture />}

      <Canvas
        camera={{ position: [20.1813, 10, 50], fov: renderPreview ? 20 : 33 }}
        gl={{ preserveDrawingBuffer: true }}
      >
        {/* <ambientLight intensity={0.5} /> */}
        <axesHelper />
        <Suspense fallback={null}>
          {renderPreview ? (
            <>
              <ModelContent></ModelContent>
              <Environment files="hdr.hdr" />
            </>
          ) : (
            <>
              <Model
                uploadedImage={uploadedImage}
                renderPreview={renderPreview}
              />
              <Environment files="hdr.hdr" />
            </>
          )}
        </Suspense>
        <OrbitControls />
      </Canvas>
    </div>
  );
};

export default EditableObject;
